import React from 'react'

// export const AudioGuidePlayerStates = { 
//   STOPPED: 'STOPPED',
//   PLAYING: 'PLAYING',
//   PAUSED: 'PAUSED'
// }

const AudioGuidePlayerContext = React.createContext({
  data: {
    category: null,
    title: null,
    url: null
  },
  setData: () => {}
})

export default AudioGuidePlayerContext


// WEBPACK FOOTER //
// ./src/contexts/AudioGuidePlayerContext.js